/* Freight to your postcode. Pairs with snippets/freight-calc.liquid.
   Freight Rule E (Jacob Morgan, 18 Oct 2026): the price comes from airless-stock-sync /api/freight-quote (data-endpoint),
   the same function as the checkout carrier service, so this matches checkout. It sends SKU, quantity, grams, unit
   price and product type for this item plus what is already in the cart. The state is for display only.
   Reads /cart.js (GET) for what is already in the cart; never writes to the cart. */
(function () {
  if (window.__aseFreightCalc) return;
  window.__aseFreightCalc = true;
  var KEY = 'ase.postcode';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var money = function (c) { return '$' + (c / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };

  function store(v) {
    try { if (v == null) return localStorage.getItem(KEY); localStorage.setItem(KEY, v); } catch (e) { return null; }
    return null;
  }

  /* State from postcode range, display only */
  var RANGES = [
    ['ACT', 200, 299], ['NT', 800, 999], ['NSW', 1000, 1999], ['NSW', 2000, 2599], ['ACT', 2600, 2618], ['NSW', 2619, 2898],
    ['ACT', 2900, 2920], ['NSW', 2921, 2999], ['VIC', 3000, 3999], ['QLD', 4000, 4999], ['SA', 5000, 5999],
    ['WA', 6000, 6797], ['WA', 6800, 6999], ['TAS', 7000, 7999], ['VIC', 8000, 8999], ['QLD', 9000, 9999]
  ];
  var STATE_NAME = { NSW: 'New South Wales', ACT: 'ACT', VIC: 'Victoria', QLD: 'Queensland', SA: 'South Australia', WA: 'Western Australia', TAS: 'Tasmania', NT: 'Northern Territory' };
  /* Outside the store's Australia zone (no province for them), so checkout will not rate them */
  var OFFSHORE = { 2899: 'Norfolk Island', 6798: 'Christmas Island', 6799: 'Cocos (Keeling) Islands' };

  function lookup(pc) {
    var n = Number(pc);
    if (OFFSHORE[n]) return { offshore: OFFSHORE[n] };
    for (var i = 0; i < RANGES.length; i++) if (n >= RANGES[i][1] && n <= RANGES[i][2]) return { state: RANGES[i][0] };
    return null;
  }

  /* Transit, as published on /pages/freight: metro and regional 2 to 5 business days (regional can take longer),
     remote 4 to 7 business days, which the page lists as WA, Tasmania, the NT and remote postcodes. */
  function transit(state) {
    if (state === 'WA' || state === 'TAS' || state === 'NT') return '4 to 7 business days';
    return '2 to 5 business days, can take longer for regional. Remote postcodes 4 to 7 business days';
  }

  var cartCache = { at: 0, cents: 0, items: [] };
  function cartData() {
    if (Date.now() - cartCache.at < 4000) return Promise.resolve(cartCache);
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var items = (c.items || []).map(function (i) {
          return { sku: i.sku || '', quantity: i.quantity, grams: i.grams || 0, price: i.price, product_type: i.product_type || '', requires_shipping: i.requires_shipping !== false };
        });
        cartCache = { at: Date.now(), cents: Number(c.total_price) || 0, items: items };
        return cartCache;
      })
      .catch(function () { return { at: 0, cents: 0, items: [] }; });
  }

  var quoteCache = {};
  function quote(endpoint, pc, items) {
    var key = pc + '|' + JSON.stringify(items);
    if (quoteCache[key]) return quoteCache[key];
    var url = endpoint + '?postcode=' + encodeURIComponent(pc) + '&items=' + encodeURIComponent(JSON.stringify(items));
    quoteCache[key] = fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || !j.ok) throw new Error(j.error || 'quote failed'); return j; }); })
      .catch(function (e) { delete quoteCache[key]; throw e; });
    return quoteCache[key];
  }

  /* Shared with the kit builder's "Delivered to" line (assets/kit-builder.js) */
  window.ASE_FREIGHT = {
    get: function () { var v = store(); var i = v && /^\d{4}$/.test(v) ? lookup(v) : null; return i && !i.offshore ? v : null; },
    quote: quote,
    endpoint: function () { var b = $('[data-fcalc]'); return b ? b.dataset.endpoint : ''; },
    focus: function () {
      var i = $('[data-fcalc="pdp"] [data-fcalc-pc]') || $('[data-fcalc-pc]');
      if (!i) return false;
      i.scrollIntoView({ block: 'center', behavior: 'smooth' });
      try { i.focus({ preventScroll: true }); } catch (e) { i.focus(); }
      return true;
    }
  };
  document.dispatchEvent(new CustomEvent('ase:fc-ready'));

  /* "Delivered to <postcode>" on the product page: this item x quantity (plus anything already in the cart, as the calculator
     does) plus the quoted freight. Hidden if the quote fails; never guessed. */
  function deliveredPrompt(box) {
    var d = $('[data-fcalc-delivered]', box);
    if (!d) return;
    d.innerHTML = '<button type="button" class="fcalc__prompt" data-fcalc-focus>Enter your postcode for a delivered price</button>';
  }
  function deliveredShow(box, pc, b, q, it) {
    var d = $('[data-fcalc-delivered]', box);
    if (!d) return;
    if (!q || !it || isNaN(it.price)) { d.innerHTML = ''; return; }
    var goods = it.price * it.qty + b.inCart;
    var total = goods + q.total_cents;
    var basis = 'This item ' + money(it.price * it.qty) + (it.qty > 1 ? ' (' + it.qty + ' x ' + money(it.price) + ')' : '') +
      (b.inCart > 0 ? ', plus ' + money(b.inCart) + ' already in your cart,' : '') +
      (q.total_cents === 0 ? ' with free freight.' : ' plus ' + money(q.total_cents) + ' freight.');
    d.innerHTML = '<p class="fcalc__dtotal">Delivered to ' + pc + ': <strong>' + money(total) + '</strong> inc GST</p>' +
      '<p class="fcalc__dnote">' + basis + ' Estimated, confirmed at checkout.</p>' +
      '<p class="fcalc__dnote">Or collect from Deception Bay QLD for <strong>' + money(goods) + '</strong>, no freight.</p>';
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-fcalc-focus]');
    if (b) { e.preventDefault(); window.ASE_FREIGHT.focus(); }
  });

  function itemLine(box) {
    var root = box.closest('[data-pdp]') || document;
    var idIn = $('input[name="id"]', root);
    var qIn = $('input[name="quantity"]', root);
    var qty = Math.max(1, parseInt(qIn && qIn.value, 10) || 1);
    var lines = {};
    try { lines = JSON.parse($('[data-fcalc-lines]', box).textContent); } catch (e) { /* none */ }
    var l = idIn ? lines[idIn.value] : null;
    if (!l) return { price: NaN, qty: qty, line: null };
    return { price: Number(l.price), qty: qty, line: { sku: l.sku || '', quantity: qty, grams: Number(l.grams) || 0, price: Number(l.price), product_type: box.dataset.ptype || '' } };
  }

  function row(dt, dd) { return '<div><dt>' + dt + '</dt><dd>' + dd + '</dd></div>'; }

  function render(box, pc) {
    var out = $('[data-fcalc-out]', box);
    var input = $('[data-fcalc-pc]', box);
    var info = lookup(pc);
    var dEl = $('[data-fcalc-delivered]', box);
    if (dEl && (!info || info.offshore)) dEl.innerHTML = '';
    var email = box.dataset.email;
    if (!info) {
      input.setAttribute('aria-invalid', 'true');
      out.innerHTML = '<p class="fcalc__err">We could not match ' + pc + ' to an Australian postcode. Check the 4 digits.</p>';
      return;
    }
    input.removeAttribute('aria-invalid');
    if (info.offshore) {
      out.innerHTML = '<p class="fcalc__err">We do not rate ' + info.offshore + ' online. Email <a href="mailto:' + email + '">' + email + '</a> for a freight quote.</p>';
      return;
    }
    var threshold = Number(box.dataset.threshold);
    var isCart = box.dataset.fcalc === 'cart';
    var graco = box.dataset.graco === 'true';

    var endpoint = box.dataset.endpoint;
    var it = null;
    var dataP = cartData();
    var basisP = dataP.then(function (c) {
      if (isCart) return { basis: c.cents || Number(box.dataset.cartCents) || 0, inCart: 0, items: c.items };
      it = itemLine(box);
      var items = c.items.slice();
      if (it.line) items.push(it.line);
      return { basis: (isNaN(it.price) ? 0 : it.price * it.qty) + c.cents, inCart: c.cents, items: items };
    });
    out.setAttribute('aria-busy', 'true');
    basisP.then(function (b) {
      return quote(endpoint, pc, b.items).then(function (q) { return { b: b, q: q }; }, function () { return { b: b, q: null }; });
    }).then(function (r) {
      var b = r.b, q = r.q;
      out.removeAttribute('aria-busy');
      deliveredShow(box, pc, b, q, it);
      var rows = '';
      if (q) {
        var heavy = q.service_code === 'heavy-goods';
        rows += row(heavy ? 'Heavy goods' : 'Freight', '<strong>' + money(q.total_cents) + '</strong>. ' + q.description + '.');
        if (!heavy) {
          if (q.total_cents === 0) rows += row('Free freight', isCart ? 'This order qualifies.' : (b.inCart > 0 ? 'This order qualifies, with your cart.' : 'This order qualifies.'));
          else if (b.basis > 0) rows += row('Free freight', 'Add ' + money(threshold - b.basis) + ' more for $0 freight (orders from ' + money(threshold) + ').');
        }
        rows += row('Area', q.zone.label);
      } else {
        rows += row('Freight', 'We could not load the rate just now. Checkout shows it before you pay.');
      }
      rows += row('Transit', transit(info.state));
      var gp = isCart ? null : document.querySelector('[data-pickup]');
      var dbTime = !graco ? '' : (isCart ? ' Within the hour if GO holds every item there, otherwise usually 3 to 5 days.' :
        (gp && gp.dataset.dbReady === 'true' ? ' Ready for collection within the hour.' : ' Usually ready in 3 to 5 days.'));
      var pick = 'Deception Bay QLD, free, any order.' + dbTime + ' Choose it at checkout.';
      if (graco) pick += '<br>Derrimut, VIC warehouse, free, for paid orders: allow 3 to 4 hours and wait for the pickup email.';
      /* 17 Oct freight policy: the three interstate pickup points are for orders of $1,000 or more (this item x qty + cart) */
      var collectMin = Number(box.dataset.collectMin) || 100000;
      pick += '<br>' + (b.basis >= collectMin
        ? 'Also Refuelling Solutions c/o Airless, for orders of ' + money(collectMin).replace('.00', '') + ' or more: Smithfield NSW (usually 2 to 4 days), Largs North SA (1 to 3 days) or Rockingham WA (4 to 7 days). Choose it at checkout.'
        : 'Orders of ' + money(collectMin).replace('.00', '') + ' or more can also collect from Refuelling Solutions c/o Airless: Smithfield NSW (usually 2 to 4 days), Largs North SA (1 to 3 days) or Rockingham WA (4 to 7 days).');
      rows += row('Pickup', pick);
      var basisNote = '';
      if (!isCart && it) {
        var line = isNaN(it.price) ? '' : money(it.price * it.qty);
        basisNote = line ? ('Worked out on ' + line + (it.qty > 1 ? ' (' + it.qty + ' x ' + money(it.price) + ')' : '') + (b.inCart > 0 ? ' plus ' + money(b.inCart) + ' already in your cart' : '') + ', inc GST.') : '';
      }
      out.innerHTML = '<p class="fcalc__where">' + STATE_NAME[info.state] + ' ' + pc + '</p><dl class="fcalc__list">' + rows + '</dl>' +
        '<p class="fcalc__note">' + (basisNote ? basisNote + ' ' : '') + 'Checkout confirms the final rate. <a href="/pages/freight">Freight details</a></p>';
    });
  }

  function bind(box) {
    if (box.__fc) return;
    box.__fc = true;
    var input = $('[data-fcalc-pc]', box);
    var form = $('form', box);
    var current = null;
    function run(pc) { current = pc; render(box, pc); }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var pc = (input.value || '').replace(/\D/g, '');
      if (pc.length !== 4) {
        current = null;
        var dd = $('[data-fcalc-delivered]', box); if (dd) dd.innerHTML = '';
        input.setAttribute('aria-invalid', 'true');
        $('[data-fcalc-out]', box).innerHTML = '<p class="fcalc__err">Enter a 4 digit Australian postcode.</p>';
        return;
      }
      var li = lookup(pc);
      if (!li || li.offshore) { current = null; render(box, pc); return; }
      store(pc);
      document.dispatchEvent(new CustomEvent('ase:postcode', { detail: pc }));
      /* Keep other placements on the page in step */
      document.querySelectorAll('[data-fcalc]').forEach(function (o) {
        var i = $('[data-fcalc-pc]', o);
        if (i && o !== box) { i.value = pc; if (o.__fc) o.__run(pc); }
      });
      run(pc);
    });
    input.addEventListener('input', function () { input.value = input.value.replace(/\D/g, '').slice(0, 4); });
    box.__run = run;
    /* Quantity or size changed: recompute for the saved postcode */
    if (box.dataset.fcalc === 'pdp') {
      var again = function () { if (current) setTimeout(function () { render(box, current); }, 0); };
      document.addEventListener('change', function (e) {
        if (e.target && (e.target.name === 'quantity' || (e.target.closest && e.target.closest('[data-variant-picker]')))) again();
      });
      document.addEventListener('input', function (e) { if (e.target && e.target.name === 'quantity') again(); });
    }
    var saved = store();
    if (saved && /^\d{4}$/.test(saved) && lookup(saved)) { input.value = saved; run(saved); }
    else deliveredPrompt(box);
  }

  function init() { document.querySelectorAll('[data-fcalc]').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  /* The cart drawer is re-rendered after every cart change */
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(init, 60); }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
